import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import { isKnownCdcLead } from '@project/shared/utils/tracking/js/tracking';
import * as Cookies from 'js-cookie';
import * as i0 from "@angular/core";
var originalLinkHref = '';
var originalvideoId = '';
var originalHrefTarget = '';
var ButtonSapcdcFunction = /** @class */ (function () {
    function ButtonSapcdcFunction() {
        this.buttonClick = new EventEmitter();
        this.classes = {
            buttonClose: 'js-m-sapcdc-lightbox__close',
            stateLightboxVisible: 'state-m-sapcdc-lightbox--visible',
            lightboxDialog: 'm-sapcdc-lightbox__dialog',
            lightboxLoading: 'm-sapcdc-lightbox__dialog-loading',
            lightbox: 'm-sapcdc-lightbox',
            stateContentHide: 'm-sapcdc-lightbox--block-hidden',
            formProductName: 'js-m-stage-product__headline',
            contactImage: 'js-m-sapcdc-form__contact-image',
            stateHasImage: 'm-sapcdc-form__has-contact-image',
            stateAdditionalFieldsVisible: 'm-sapcdc-form__show-additional-fields',
            rowHide: 'cdcFormRowHide',
            autoSuggestDropdown: 'js-m-sapcdc-form_product-autosuggest',
            dropdownItem: 'js-m-sapcdc-form_dropdown-item',
        };
    }
    ButtonSapcdcFunction.prototype.onDownloadBtnClicked = function (e, cdcLightboxComponent) {
        var flowId = $(e.target).data('formflow-id');
        var closeButtonDisabled = $(e.target).data('formflow-close-disabled');
        var videoId = $(e.target).data('video-id');
        var campaignId = $(e.target).data('formcampaign-main-id');
        var href = $(e.target).attr('href');
        var target = $(e.target).attr('target');
        var themeModeAttribute = $(e.target).data('mkto-themeattribute');
        this.sapCdclightboxComponent = cdcLightboxComponent;
        e.stopPropagation();
        e.preventDefault();
        if (flowId != undefined) {
            if (flowId.length > 0) {
                if (!Track.isKnownCdcLead()) {
                    this.getCdcLightboxView(flowId, href, closeButtonDisabled, themeModeAttribute, campaignId, videoId, target);
                    return false;
                }
                else {
                    this.getCdcLightboxData(flowId, href, closeButtonDisabled, themeModeAttribute, campaignId, videoId, target);
                }
            }
            else {
                console.log('lightbox: flow-id is empty');
            }
        }
        else {
            console.log('lightbox: flow-id is undefined');
        }
        if (this.emitEvent === true) {
            this.buttonClick.emit();
        }
    };
    ButtonSapcdcFunction.prototype.getCdcLightboxView = function (flowId, originalHref, closeButtonDisabled, themeModeAttribute, campaignId, videoId, target) {
        var _this_1 = this;
        if (themeModeAttribute === void 0) { themeModeAttribute = ''; }
        if (campaignId === void 0) { campaignId = ''; }
        if (videoId === void 0) { videoId = ''; }
        if (target === void 0) { target = ''; }
        // partial view is called, show black-transparent overlay and loading indicator
        this.showLightbox();
        this.showIndicator();
        if (closeButtonDisabled == undefined) {
            closeButtonDisabled = false;
        }
        if (originalHref == undefined) {
            originalHref = '';
        }
        if (themeModeAttribute === undefined || themeModeAttribute === null || themeModeAttribute === '') {
            themeModeAttribute = $('html').hasClass('l-campaign') ? 'l-campaign' : themeModeAttribute;
        }
        var formProductName = $('html').find("." + this.classes.formProductName);
        if (formProductName.length > 0) {
            this.productNameValue = $(formProductName[0]).text();
        }
        var endpoint = '/partial-updates/sapcdc/lightboxpartial';
        $.ajax({
            type: 'get',
            url: endpoint,
            dataType: 'html',
            data: {
                flowId: flowId,
                originLink: originalHref,
                closeButtonDisabled: closeButtonDisabled,
                themeModeAttribute: themeModeAttribute,
                campaignId: campaignId,
                productName: this.productNameValue,
            },
            success: function (response) {
                if (response.length > 2) {
                    var $dialog = _this_1.sapCdclightboxComponent.find("div." + _this_1.classes.lightboxDialog);
                    $dialog.empty();
                    $dialog.append(response);
                    _this_1.rebindEvents();
                    _this_1.loadForm(originalHref, videoId, target);
                }
                else {
                    console.log('lightbox: get partial-view failed');
                    _this_1.closeLightbox();
                    _this_1.doSubmitAction(false, originalHref, videoId);
                }
            },
            complete: function () { },
            error: function (xhr, status, error) {
                console.log("lightbox: get partial-view error, endpoint: " + endpoint + ", " + xhr.status + ", " + xhr.statusText + ", " + error);
                _this_1.doSubmitAction(false, originalHref, videoId);
            },
        });
    };
    ButtonSapcdcFunction.prototype.getCdcLightboxData = function (flowId, originalHref, closeButtonDisabled, themeModeAttribute, campaignId, videoId, target) {
        var _this_1 = this;
        if (themeModeAttribute === void 0) { themeModeAttribute = ''; }
        if (campaignId === void 0) { campaignId = ''; }
        if (videoId === void 0) { videoId = ''; }
        if (target === void 0) { target = ''; }
        var _this = this;
        var clickEventTriggered = false;
        if (closeButtonDisabled == undefined) {
            closeButtonDisabled = false;
        }
        if (originalHref == undefined) {
            originalHref = '';
        }
        if (themeModeAttribute === undefined || themeModeAttribute === null || themeModeAttribute === '') {
            themeModeAttribute = $('html').hasClass('l-campaign') ? 'l-campaign' : themeModeAttribute;
        }
        this.showLightbox();
        this.showIndicator();
        $.ajax({
            type: 'get',
            url: window.location.origin +
                '/partial-updates/sapcdc/lightboxpartialformdata?' +
                'flowId=' +
                flowId +
                '&originLink=' +
                originalHref +
                '&isDisplayForm=true' +
                '&campaignId=' +
                campaignId,
            dataType: 'html',
            success: function (response) {
                if (response.length > 2) {
                    _this_1.closeLightbox();
                    var $dialog = _this.sapCdclightboxComponent.find("div." + _this_1.classes.lightboxDialog);
                    $dialog.empty();
                    $dialog.append(response);
                    _this.rebindEvents();
                    var $lightboxContainer = _this.sapCdclightboxComponent.find("div[data-id=\"SapCdcLightboxContainer\"]");
                    _this_1.setCampaignId($lightboxContainer);
                    var IsHiddenFormSubmitrequired = $lightboxContainer.data('hidden-form-submit-required');
                    var HiddenFormSubmitId = $lightboxContainer.data('lightbox-form-id');
                    var $mainFormContainer = $lightboxContainer.find("div[data-id=\"formContainerForSapCdc\"]");
                    var sendDataToPreferences = $($mainFormContainer).attr('data-cdp-send-preferences-data');
                    var submissionType = $($mainFormContainer).attr('data-form-submission-type');
                    var submissionSource = $($mainFormContainer).attr('data-form-submission-source');
                    if (IsHiddenFormSubmitrequired == true) {
                        var cdcProfileData = Cookies.getJSON('cdcProfileData');
                        if (cdcProfileData) {
                            var selectedPreference = sendDataToPreferences !== undefined && sendDataToPreferences === 'true'
                                ? encodeURIComponent(window.dataLayer[0].preferenceTag)
                                : '';
                            SubmitWebContentDownloadPreferences(submissionType, submissionSource, selectedPreference, cdcProfileData, campaignId);
                            setTimeout(function () {
                                if (HiddenFormSubmitId !== undefined && clickEventTriggered !== true) {
                                    if (originalHref != undefined && originalHref.length > 0) {
                                        clickEventTriggered = true;
                                        window.open(originalHref, target);
                                    }
                                }
                            }, 300);
                        }
                    }
                    else {
                        window.open(originalHref, target);
                    }
                }
                else {
                    console.log('lightbox: get partial-view failed');
                    _this.closeLightbox();
                    _this.doSubmitAction(false, '', '');
                }
            },
            complete: function () {
                _this.hideIndicator();
            },
        });
    };
    ButtonSapcdcFunction.prototype.SubmitWebContentDownloadPreferences = function (submissionType, submissionSource, selectedPreference, profile, campaignId) {
        $.ajax({
            type: 'GET',
            url: window.location.origin +
                '/partial-updates/sapcdc/updatepreferencesincdp?' +
                'userPreference=' +
                selectedPreference +
                '&emailId=' +
                encodeURIComponent(profile.email) +
                '&campaignId=' +
                campaignId +
                '&submissionType=' +
                submissionType +
                '&submissionSource=' +
                submissionSource +
                '&firstName=' +
                profile.firstName +
                '&lastName=' +
                profile.lastName +
                '&formUrl=' +
                encodeURIComponent(window.location.href),
            dataType: 'html',
            success: function (response) {
                console.log('Web content download preferences updated successfully.');
            },
            error: function (xhr, status, error) {
                console.error('Error updating web content download preferences:', status, error);
            },
        });
    };
    ButtonSapcdcFunction.prototype.loadForm = function (originalHref, videoId, target) {
        if (videoId === void 0) { videoId = ''; }
        if (target === void 0) { target = ''; }
        var _this = this;
        var $formContainer = this.sapCdclightboxComponent.find("div[data-id=\"formContainer\"]");
        setTimeout(function () {
            var formId = $formContainer.data('form-id');
            var screenSetId = $formContainer.data('screen-set-id');
            var contextLang = $formContainer.data('context-language');
            _this.hideIndicator();
            _this.displayFormBox();
            _this.loadSapCdcForm(formId, screenSetId, contextLang, null, originalHref, videoId, target);
        }, 3000);
    };
    ButtonSapcdcFunction.prototype.loadSapCdcForm = function (formId, screenSetId, contextLang, errorMsg, originalHref, videoId, target) {
        if (originalHref === void 0) { originalHref = ''; }
        if (videoId === void 0) { videoId = ''; }
        if (target === void 0) { target = ''; }
        var $this = this;
        var gigyaSapCdc = window['gigya'];
        console.log('Gigya Settings loadSapCdcForm----' + gigyaSapCdc);
        originalLinkHref = originalHref;
        originalvideoId = videoId;
        originalHrefTarget = target;
        if (typeof gigyaSapCdc != 'undefined') {
            var formContainerId = 'sapCdcForm_' + formId;
            gigyaSapCdc.accounts.showScreenSet({
                screenSet: screenSetId,
                startScreen: formId,
                containerID: formContainerId,
                lang: contextLang,
                onAfterScreenLoad: function (eventObj) {
                    console.log('Screen Loaded:', eventObj.sourceContainerID);
                    $this.updateFormFields(eventObj, errorMsg);
                    $this.setFormStartDataToGtm(eventObj.sourceContainerID);
                },
                onBeforeSubmit: function (event) {
                    console.log('Before submit event:', event);
                },
                onAfterSubmit: function (event) {
                    console.log('After submit event:', event);
                    if (event !== null && event.response !== null && event.response.UID !== null) {
                        $this.onSapCdcAfterSubmitForLightBox(event, $this.classes.stateContentHide, originalLinkHref, originalvideoId, originalHrefTarget);
                        $this.submitDataToGtm('sapCdcForm_' + event.screen);
                    }
                },
                onSubmitSuccess: function (event) {
                    console.log('Submit success:', event);
                },
                onError: function (error) {
                    console.error('Submit error:', error);
                },
            });
        }
    };
    ButtonSapcdcFunction.prototype.updateFormFields = function (eventObj, errorMsg) {
        console.log('Screen ID on After Screen Load: ' + eventObj.sourceContainerID);
        var container = document.getElementById(eventObj.sourceContainerID);
        if (container) {
            var sitecoreFromId = container.getAttribute('data-sitecore-form-id');
            if (sitecoreFromId) {
                var divElement = document.getElementById(sitecoreFromId);
                if (divElement) {
                    divElement.style.display = 'none';
                }
                var formElement = divElement.querySelector('form');
                var scDateboxes = formElement.querySelectorAll("input[type='date']");
                updateDateBoxes(scDateboxes);
            }
            var numberboxes = container.querySelectorAll("input[type='number']");
            var textboxes = container.querySelectorAll("input[type='text']");
            var selectboxes = container.querySelectorAll('select');
            var dateboxes = container.querySelectorAll("input[type='date']");
            updateNumberBoxes(numberboxes, errorMsg);
            updateNumberBoxes(textboxes, errorMsg);
            updateDateBoxes(dateboxes);
            updateSelectList(selectboxes);
            this.setCampaignId(container);
        }
        else {
            console.error('Container not found:', eventObj.sourceContainerID);
        }
    };
    ButtonSapcdcFunction.prototype.onSapCdcAfterSubmitForLightBox = function (event, stateContentHide, originalHref, videoId, target) {
        var userDetails = this.getUserDetails(event);
        var cdcFormContainer = document.getElementById('sapCdcForm_' + event.screen);
        var sitecoreFromId = cdcFormContainer.getAttribute('data-sitecore-form-id');
        var showSitecoreForm = cdcFormContainer.getAttribute('data-is-show-sitecore-form-on-submit');
        var campaignId = cdcFormContainer.getAttribute('data-form-campaign-id');
        var $formContainer = cdcFormContainer.closest('[data-id="formContainer"]');
        var showMessage = Boolean($formContainer.closest('[data-id="formContainer"]').parentElement.getAttribute('data-show-message'));
        if (showSitecoreForm === undefined || showSitecoreForm === 'false') {
            console.log('After submit event UID:', event.response.UID);
            if (showMessage) {
                Track.setKnownCdcLead(true);
                this.doSubmitAction(true, originalHref, videoId, '');
                $formContainer.classList.add(stateContentHide);
                var $confirmContainer = $formContainer.parentElement.querySelectorAll('div[data-id="confirmationContainer"]');
                if ($confirmContainer !== undefined && $confirmContainer !== null) {
                    var confirmContainerElement = $confirmContainer[0];
                    confirmContainerElement.classList.remove(stateContentHide);
                }
                if (videoId.length > 0) {
                    //play
                    $('[data-video-id="' + videoId + '"] .mi-big-play-cover').trigger('click');
                    $('[data-video-id="' + videoId + '"] .js-a-video__locked').remove();
                }
                else {
                    if (originalHref != undefined && originalHref.length > 0) {
                        window.open(originalHref, target);
                        //this.triggerClickEvent(originalHref, target);
                    }
                }
                var sendDataToPreferences = cdcFormContainer.getAttribute('data-cdp-send-preferences-data');
                if (sendDataToPreferences !== undefined && sendDataToPreferences) {
                    cdpSubmitCallForCdcForms(cdcFormContainer, userDetails, campaignId);
                }
            }
        }
        else {
            if (sitecoreFromId) {
                var sitecoreForm = document.getElementById(sitecoreFromId);
                if (sitecoreForm) {
                    sitecoreForm.previousElementSibling.style.display = 'none';
                    sitecoreForm.style.display = 'block';
                    $(sitecoreForm)
                        .find("input[data-sc-field-name='PrimaryEmailAddress']")
                        .val(userDetails.email);
                    $(sitecoreForm)
                        .find("input[data-sc-field-name='IndustryInterest']")
                        .val(userDetails.cov_industry);
                    $(sitecoreForm)
                        .find("input[data-sc-field-name='CdcCampaignId']")
                        .val(campaignId);
                    $(sitecoreForm)
                        .find("input[data-sc-field-name='FirstName']")
                        .val(userDetails.firstName);
                    $(sitecoreForm)
                        .find("input[data-sc-field-name='LastName']")
                        .val(userDetails.lastName);
                    this.productAutoSuggest(sitecoreForm.previousElementSibling, sitecoreForm);
                    $(sitecoreForm)
                        .find('.js-form__button-cdp-submit')
                        .on('click', function (eventClick) {
                        cdpSubmitCallForSitecoreForms(eventClick);
                    });
                }
            }
            else {
                $formContainer.classList.add(stateContentHide);
                var $confirmContainer = $formContainer.parentElement.querySelectorAll('div[data-id="confirmationContainer"]');
                if ($confirmContainer !== undefined && $confirmContainer !== null) {
                    var confirmContainerElement = $confirmContainer[0];
                    confirmContainerElement.classList.remove(stateContentHide);
                }
            }
        }
    };
    ButtonSapcdcFunction.prototype.getUserDetails = function (event) {
        var userCookieStr, workCookieData, profileCookieData, userProfileData, newSubscriptionInfo;
        if (Cookies.get('cdcUserData') === undefined && Cookies.get('cdcProfileData') === undefined) {
            this.addCdcDataToCookie(event);
        }
        else {
            userCookieStr = Cookies.get('cdcUserData');
            if (userCookieStr) {
                var cookieObjects = userCookieStr.split('|');
                if (cookieObjects.length > 0) {
                    userProfileData = JSON.parse(cookieObjects[0]);
                    workCookieData = JSON.parse(cookieObjects[1]);
                    if (event && event.data && event.data.work && event.data.work.cov_job_function) {
                        workCookieData.work.cov_job_function = event.data.work.cov_job_function;
                    }
                    else {
                        if (workCookieData && workCookieData.work && workCookieData.work.cov_job_function) {
                            workCookieData.work['cov_job_function'] = workCookieData.work.cov_job_function;
                        }
                    }
                    if (event && event.data && event.data.work && event.data.work.cov_department) {
                        workCookieData.work.cov_department = event.data.work.cov_department;
                    }
                    else {
                        if (workCookieData && workCookieData.work && workCookieData.work.cov_department) {
                            workCookieData.work['cov_department'] = workCookieData.work.cov_department;
                        }
                    }
                    if (event && event.data && event.data.work && event.data.work.cov_job_title) {
                        workCookieData.work.cov_job_title = event.data.work.cov_job_title;
                    }
                    else {
                        if (workCookieData && workCookieData.work && workCookieData.work.cov_job_title) {
                            workCookieData.work['cov_job_title'] = workCookieData.work.cov_job_title;
                        }
                    }
                    if (event && event.data && event.data.work && event.data.work.cov_industry) {
                        workCookieData.work.cov_industry = event.data.work.cov_industry;
                    }
                    else {
                        if (workCookieData && workCookieData.work && workCookieData.work.cov_industry) {
                            workCookieData.work['cov_industry'] = workCookieData.work.cov_industry;
                        }
                    }
                    if (event && event.data && event.data.cov_consent_source && userProfileData && userProfileData.country && userProfileData.country !== "US") {
                        workCookieData.cov_consent_source = event.data.cov_consent_source;
                    }
                    if (event && event.data && event.data.cov_consent_source_implicit && userProfileData && userProfileData.country && userProfileData.country === "US") {
                        workCookieData.cov_consent_source_implicit = event.data.cov_consent_source_implicit;
                    }
                }
            }
            profileCookieData = JSON.parse(Cookies.get('cdcProfileData'));
            if (profileCookieData !== undefined && profileCookieData.phones !== undefined) {
                if (event && event.profile && event.profile.phones && event.profile.phones.number) {
                    profileCookieData.phones.number = event.profile.phones.number;
                }
            }
            else {
                if (event && event.profile && event.profile.phones && event.profile.phones.number) {
                    profileCookieData = {
                        firstName: profileCookieData.firstName,
                        lastName: profileCookieData.lastName,
                        email: profileCookieData.email,
                        country: profileCookieData.country,
                        phones: {
                            number: event.profile.phones.number,
                        },
                    };
                }
            }
        }
        var firstName, lastName, email, industry;
        if (workCookieData && profileCookieData) {
            Cookies.set('cdcUserData', JSON.stringify(profileCookieData) +
                '|' +
                JSON.stringify(workCookieData), { expires: 365 });
            Cookies.set('cdcProfileData', profileCookieData, { expires: 365 });
            firstName = profileCookieData.firstName;
            lastName = profileCookieData.lastName;
            email = profileCookieData.email;
            industry = workCookieData && workCookieData.work && workCookieData.work.cov_industry;
            ;
        }
        else {
            firstName = event.profile.firstName;
            lastName = event.profile.lastName;
            email = event.profile.email;
            industry = event && event.data && event.data.work && event.data.work.cov_industry;
        }
        return { firstName: firstName, lastName: lastName, email: email, industry: industry };
    };
    ButtonSapcdcFunction.prototype.addCdcDataToCookie = function (event) {
        var profileData = JSON.stringify(event.profile);
        var workData = JSON.stringify(event.data);
        Cookies.set('cdcProfileData', profileData, { expires: 365 });
        Cookies.set('cdcUserData', profileData + '|' + workData, { expires: 365 });
    };
    ButtonSapcdcFunction.prototype.rebindEvents = function () {
        var $this = this;
        this.sapCdclightboxComponent.find("." + this.classes.buttonClose).on('click', function () {
            $this.closeLightbox();
        });
    };
    ButtonSapcdcFunction.prototype.removeCloseEvents = function () {
        var $this = this;
        this.sapCdclightboxComponent.find("." + this.classes.buttonClose).off('click', function () {
            $this.closeLightbox();
        });
    };
    ButtonSapcdcFunction.prototype.showLightbox = function () {
        $('html')
            .find("." + this.classes.lightbox)
            .addClass(this.classes.stateLightboxVisible);
        $('html').addClass('no-scrolling--without-scrollbar');
    };
    ButtonSapcdcFunction.prototype.closeLightbox = function () {
        this.sapCdclightboxComponent.removeClass(this.classes.stateLightboxVisible);
        this.sapCdclightboxComponent.find("." + this.classes.lightboxDialog).empty();
        $('html').removeClass('no-scrolling--without-scrollbar');
    };
    ButtonSapcdcFunction.prototype.displayConfirmationBox = function () {
        var $confirmContainer = this.sapCdclightboxComponent.find("div[data-id=\"confirmationContainer\"]");
        $confirmContainer.removeClass(this.classes.stateContentHide);
    };
    ButtonSapcdcFunction.prototype.displayFormBox = function () {
        var $formContainer = this.sapCdclightboxComponent.find("div[data-id=\"formContainer\"]");
        $formContainer.removeClass(this.classes.stateContentHide);
    };
    ButtonSapcdcFunction.prototype.hideFormBox = function () {
        var $formContainer = this.sapCdclightboxComponent.find("div[data-id=\"formContainer\"]");
        $formContainer.addClass(this.classes.stateContentHide);
    };
    ButtonSapcdcFunction.prototype.hideIndicator = function () {
        var $dialog = this.sapCdclightboxComponent.find("." + this.classes.lightboxDialog);
        $dialog.removeClass(this.classes.stateContentHide);
        var $indicator = this.sapCdclightboxComponent.find("." + this.classes.lightboxLoading);
        $indicator.addClass(this.classes.stateContentHide);
    };
    ButtonSapcdcFunction.prototype.showIndicator = function () {
        var $dialog = this.sapCdclightboxComponent.find("." + this.classes.lightboxDialog);
        $dialog.addClass(this.classes.stateContentHide);
        var $indicator = this.sapCdclightboxComponent.find("." + this.classes.lightboxLoading);
        $indicator.removeClass(this.classes.stateContentHide);
    };
    ButtonSapcdcFunction.prototype.triggerClickEvent = function (originalHref, target) {
        // Create the <a> element
        var link = document.createElement('a');
        link.href = originalHref;
        link.download = originalHref.split('/').slice(-1)[0];
        link.target = target;
        // Append it to the DOM temporarily
        document.body.appendChild(link);
        // Perform any action, e.g., programmatic click
        link.click();
        // Remove the element from the DOM
        link.remove(); // Removes the <a> element from the DOM
    };
    ButtonSapcdcFunction.prototype.doSubmitAction = function (showConfirmationMsg, originalHref, videoId, target) {
        if (videoId === void 0) { videoId = ''; }
        if (target === void 0) { target = ''; }
        //unlock
        $('.a-video--locked').removeClass('a-video--locked');
        $('.m-download-item--locked').removeClass('m-download-item--locked');
        $('.m-download-table__item--locked').removeClass('m-download-table__item--locked');
        $('.m-hero-article-stage--locked').removeClass('m-hero-article-stage--locked');
        $('.m-scrollable-teaser-item--locked').removeClass('m-scrollable-teaser-item--locked');
        $('.m-talk--locked').removeClass('m-talk--locked');
        $('.m-teaser-large--locked').removeClass('m-teaser-large--locked');
        $('.o-teaser-content-area__item').each(function (i, e) {
            var $teaser = $(e).children();
            var classList = $teaser.attr('class');
            var className = classList.split(' ');
            $teaser.removeClass(className[0] + '--locked');
        });
    };
    ButtonSapcdcFunction.prototype.setFormStartDataToGtm = function (containerId) {
        var formNode = this.sapCdclightboxComponent.find('div[id="' + containerId + '"]');
        var isSendDataToGtmOnPageLoad = formNode.data('sc-send-data-to-gtm-pageload');
        if (isSendDataToGtmOnPageLoad) {
            var typeOfForm = formNode.data('form-name');
            var trackdata = {
                event: 'form_start',
                form_id: $(formNode).attr('id'),
                form_name: typeOfForm,
                form_destination: '',
                form_submit_text: '',
            };
            Track.gtmTrack(trackdata);
        }
    };
    ButtonSapcdcFunction.prototype.submitDataToGtm = function (containerId) {
        var $this = this;
        var formNode = this.sapCdclightboxComponent.find('div[id="' + containerId + '"]');
        var IsSendDataToGtm = formNode.data('sc-send-data-to-gtm');
        if (IsSendDataToGtm) {
            var typeOfForm = formNode.data('form-name');
            var trackdata = {
                event: 'form_submit',
                form_id: $(formNode).attr('id'),
                form_name: typeOfForm,
                form_destination: '',
                form_submit_text: '',
            };
            Track.gtmTrack(trackdata);
        }
    };
    ButtonSapcdcFunction.prototype.setCampaignId = function (container) {
        var campaignIdContainer = $(container).closest('.m-sapcdc-form').length > 0
            ? $(container).closest('.m-sapcdc-form')
            : $(container).closest('div[data-id="formContainer"]').length > 0
                ? $(container).closest('div[data-id="formContainer"]')
                : $(container).find('div[data-id="formContainer"]');
        var campaignId = $(campaignIdContainer).data('cdcflow-campaignid');
        var formcampaignId = $(campaignIdContainer).data('cdcflow-formcampaignid');
        var siteCampaignId = $(campaignIdContainer).data('cdcflow-sitecampaignid');
        var $formContainer = $(container).find("div[data-id='formContainer']");
        if (campaignId === undefined) {
            campaignId = $formContainer.data('cdcflow-campaignid');
        }
        if (formcampaignId === undefined) {
            formcampaignId = $formContainer.data('cdcflow-formcampaignid');
        }
        if (siteCampaignId === undefined) {
            siteCampaignId = $formContainer.data('cdcoflow-sitecampaignid');
        }
        var urlParams = new URLSearchParams(window.location.search);
        var utmId = '';
        if (urlParams.has('utm_id')) {
            utmId = urlParams.get('utm_id');
        }
        if (typeof utmId === 'string' && utmId.length === 0) {
            if (typeof campaignId === 'undefined') {
                if (typeof formcampaignId === 'undefined') {
                    $(container).attr('data-form-campaign-id', siteCampaignId);
                }
                else {
                    $(container).attr('data-form-campaign-id', formcampaignId);
                }
            }
            else {
                $(container).attr('data-form-campaign-id', campaignId);
            }
        }
        else {
            $(container).attr('data-form-campaign-id', utmId);
        }
    };
    // translate field label by field name
    ButtonSapcdcFunction.prototype.translate = function (form, $component) {
        var CdcForms2 = window['CdcForms2'];
        var formEl = form.getFormElem()[0];
        var ANCESTORS_STOR = '.cdcFormRow, .cdcFormCol', INPUTS_STOR = 'INPUT, SELECT, TEXTAREA, BUTTON', attrTag = 'data-wrapper-for', _forEach = Array.prototype.forEach;
        // utility fn: tag outer wrapper DIVs with their inner inputs' names to make them seekable
        (function tagCdcWrappers(formEl) {
            _forEach.call(formEl.querySelectorAll(ANCESTORS_STOR), function (ancestor) {
                ancestor.setAttribute(attrTag, '');
                _forEach.call(ancestor.querySelectorAll(INPUTS_STOR), function (input) {
                    var currentTag = ancestor.getAttribute(attrTag);
                    ancestor.setAttribute(attrTag, [currentTag ? currentTag : '', input.name].join(' ').trim());
                });
            });
        })(formEl);
        var translateMapEl = $component.find("[data-map-id=\"translateMap\"]"); // get translations embedded in form rich text area
        var jsonStr = translateMapEl.text();
        if (jsonStr.length > 0) {
            var translateMap = JSON.parse(jsonStr);
            var currentTranslations = translateMap;
            // loop over translatables
            var fieldName, fieldTranslations, propertyName, propertyValue, translateTargetEl;
            for (fieldName in currentTranslations) {
                fieldTranslations = currentTranslations[fieldName];
                for (propertyName in fieldTranslations) {
                    propertyValue = fieldTranslations[propertyName];
                    switch (propertyName) {
                        case 'label':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] LABEL');
                            if (translateTargetEl != null) {
                                translateTargetEl.lastChild.nodeValue = propertyValue;
                            }
                            break;
                        case 'validation':
                            translateTargetEl = CdcForms2.$(formEl.querySelector('[data-wrapper-for="' + fieldName + '"] .cdcFieldDescriptor'));
                            if (translateTargetEl != null) {
                                var cdcFieldDescriptor = translateTargetEl.data('cdcFieldDescriptor');
                                if (cdcFieldDescriptor != undefined) {
                                    cdcFieldDescriptor.validationMessage = propertyValue;
                                }
                            }
                            break;
                        case 'placeholder':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] INPUT');
                            if (translateTargetEl != null) {
                                translateTargetEl.setAttribute('placeholder', propertyValue);
                            }
                            break;
                        case 'submit':
                            translateTargetEl = formEl.querySelector('BUTTON[type="submit"]');
                            if (translateTargetEl != null) {
                                translateTargetEl.innerHTML = propertyValue;
                            }
                            break;
                        case 'html':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"]');
                            if (translateTargetEl != null) {
                                translateTargetEl.innerHTML = propertyValue;
                            }
                            break;
                        case 'options':
                            translateTargetEl = formEl.querySelectorAll('[data-wrapper-for="' + fieldName + '"] OPTION');
                            for (var i = 0; i < translateTargetEl.length; i++) {
                                var val = translateTargetEl[i].value;
                                var txt = propertyValue[val];
                                if (typeof txt !== 'undefined') {
                                    translateTargetEl[i].text = txt;
                                }
                            }
                            break;
                        case 'checkbox':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] .cdcCheckboxList');
                            if (translateTargetEl != null) {
                                var labelEle = translateTargetEl.parentElement.querySelector('label');
                                labelEle.innerHTML = propertyValue;
                            }
                            break;
                        case 'fieldset':
                            translateTargetEl = formEl.querySelector('[data-wrapper-for="' + fieldName + '"] fieldset legend');
                            if (translateTargetEl != null) {
                                translateTargetEl.innerText = propertyValue;
                            }
                            break;
                        case 'submitprogress':
                            translateTargetEl = formEl.querySelector('BUTTON[type="submit"]');
                            if (translateTargetEl != null) {
                                translateTargetEl.setAttribute('data-submit-progress-text', propertyValue);
                                form.onSubmit(function (form) {
                                    if (form.submittable()) {
                                        translateTargetEl.innerHTML = translateTargetEl.getAttribute('data-submit-progress-text');
                                    }
                                });
                            }
                            break;
                    }
                }
            }
        }
    };
    ButtonSapcdcFunction.prototype.sortSelectOptions = function (form) {
        var formEl = form.getFormElem()[0];
        var $form = $(formEl);
        var language = $('html').attr('lang');
        var $selectEles = $form.find('select');
        $selectEles.each(function (i, e) {
            var $options = $(e).find('option');
            var $defaultOption = $options.filter("option[value='']");
            // get the "Other" option in dropdown list
            var $othersOption = $options.filter(function (optIndex, optEle) {
                var optValue = $(optEle)
                    .val()
                    .toString()
                    .toLocaleLowerCase();
                var result = optValue == 'others' || optValue == 'other';
                return result;
            });
            var $optionEles = $options.toArray().sort(function (a, b) {
                var aText = $(a).text();
                var bText = $(b).text();
                var result = aText.localeCompare(bText, language, {
                    ignorePunctuation: true,
                });
                return result;
            });
            $(e).empty();
            $(e).append($optionEles);
            // make the "Select..." option at the top
            if ($defaultOption && $defaultOption.length > 0) {
                $(e).prepend($defaultOption);
            }
            // make the "Others" option at the bottom
            if ($othersOption && $othersOption.length > 0) {
                $(e).append($othersOption);
            }
            var id = $(e).attr('id');
            if (id !== 'formVersion' || (id == 'formVersion' && isKnownCdcLead() == false)) {
                // make sure the first option is selected
                $(e)
                    .find('option')
                    .first()
                    .prop('selected', true);
            }
        });
    };
    ButtonSapcdcFunction.prototype.formatPhoneNumber = function (form) {
        var vals = form.vals();
        var phone = vals.Phone;
        if (typeof phone !== 'undefined') {
            var formattedPhone = phone.replace(/[^0-9]/g, '').replace(/^0*/g, '');
            form.vals({ Phone: formattedPhone });
        }
    };
    ButtonSapcdcFunction.prototype.prefillForm = function (form, $component) {
        var _this = this;
        var prefilledFieldsEle = $component.find("div[data-map-id='prefillFields']");
        var prefilledJsonStr = prefilledFieldsEle.text();
        if (prefilledJsonStr.length > 0) {
            var prefillFields = JSON.parse(prefilledJsonStr);
            var formFieldEles = $component.find('div.cdcFormRow');
            var _loop_1 = function () {
                var fieldValue = prefillFields[fieldName];
                formFieldEles.each(function (i, e) {
                    var $fieldEle = $(e);
                    var formFieldId = $fieldEle.data('wrapper-for');
                    if (fieldName.toLocaleLowerCase() == formFieldId.toLocaleLowerCase()) {
                        if (fieldValue != null) {
                            var type = $fieldEle.find('input').attr('type');
                            if (type == 'checkbox') {
                                if (fieldValue == 'true') {
                                    fieldValue = 'yes';
                                }
                            }
                            var obj = _this.GenerateObject(formFieldId, fieldValue);
                            form.vals(obj);
                        }
                    }
                });
            };
            for (var fieldName in prefillFields) {
                _loop_1();
            }
        }
    };
    ButtonSapcdcFunction.prototype.GenerateObject = function (formFieldId, formFieldValue) {
        var jsonStr = "{\"" + formFieldId + "\":\"" + formFieldValue + "\"}";
        var obj = JSON.parse(jsonStr);
        return obj;
    };
    ButtonSapcdcFunction.prototype.initCheckboxOrder = function ($component) {
        var $formCheckbox = $component.find('[type="checkbox"]');
        if ($formCheckbox.length > 0) {
            $formCheckbox.parents('.cdcFormRow').css('order', '1');
        }
    };
    ButtonSapcdcFunction.prototype.initContactImage = function ($component) {
        var $contactImage = $component.find("." + this.classes.contactImage);
        var $formMessage = $component.find("textarea[name='formMessage']");
        if ($contactImage.length > 0 && $formMessage.length > 0) {
            $component.addClass(this.classes.stateHasImage);
        }
    };
    ButtonSapcdcFunction.prototype.initMessageBox = function ($component) {
        var _this_1 = this;
        $component.find("textarea[name='formMessage']").on('focus', function (ev) {
            $component.addClass(_this_1.classes.stateAdditionalFieldsVisible);
        });
    };
    ButtonSapcdcFunction.prototype.updateFieldAttributes = function (form, $component) {
        var $formEl = $(form.getFormElem()[0]);
        var rando = new Date().getTime() + parseInt((Math.random() * 1000).toString());
        var $checkboxes = $formEl.find('.cdcField');
        $checkboxes.each(function (i, e) {
            var $chk = $(e);
            var chkId = $chk.attr('id');
            var newChkId = chkId + "_" + rando;
            if (chkId != undefined) {
                if (!chkId.includes('_')) {
                    // update checkbox id
                    $chk.attr('id', newChkId);
                    // update label-for attribute
                    $chk.parents('.cdcFieldWrap')
                        .find("label[for=" + chkId + "]")
                        .attr('for', newChkId);
                }
            }
        });
        var formId = $formEl.attr('id');
        var newFormId = formId + "_" + rando;
        if (formId != undefined) {
            if (!formId.includes('_', 9)) {
                $formEl.attr('id', newFormId);
            }
        }
    };
    ButtonSapcdcFunction.prototype.hideFields = function ($component) {
        var $this = this;
        var hiddenFieldsStr = $component.find("div[data-map-id='hiddenFields']").text();
        var hiddenFieldsArr = hiddenFieldsStr.split(',');
        var campaignId = $component.data('cdcflow-campaignid');
        var formcampaignId = $component.data('cdcflow-formcampaignid');
        var siteCampaignId = $component.data('cdcflow-sitecampaignid');
        var $formContainer = $component.find("div[data-id='formContainer']");
        if (campaignId === undefined) {
            campaignId = $formContainer.data('cdcflow-campaignid');
        }
        if (formcampaignId === undefined) {
            formcampaignId = $formContainer.data('cdcflow-formcampaignid');
        }
        if (siteCampaignId === undefined) {
            siteCampaignId = $formContainer.data('cdcflow-sitecampaignid');
        }
        var formFieldEles = $component.find('div.cdcFormRow');
        var _loop_2 = function () {
            var fieldName = hiddenFieldsArr[field];
            formFieldEles.each(function (i, e) {
                var $fieldEle = $(e);
                var formFieldId = $fieldEle.data('wrapper-for');
                if (fieldName.toLocaleLowerCase() == formFieldId.toLocaleLowerCase()) {
                    $fieldEle.addClass($this.classes.rowHide);
                }
            });
        };
        for (var field in hiddenFieldsArr) {
            _loop_2();
        }
        formFieldEles.each(function (i, e) {
            var $fieldEle = $(e);
            var formFieldId = $fieldEle.data('wrapper-for');
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden') {
                $fieldEle.addClass($this.classes.rowHide);
            }
            if (formFieldId == '') {
                $fieldEle.addClass($this.classes.rowHide);
            }
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceIndustry') {
                $fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPageIndustrytags').val());
            }
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceMaterial') {
                $fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPageMaterialtags').val());
            }
            if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'tempPreferenceTheme') {
                $fieldEle.find('input[name="' + formFieldId + '"]').val($('#frmPagePreferenceTheme').val());
            }
            var urlParams = new URLSearchParams(window.location.search);
            var utmId = '';
            if (urlParams.has('utm_id')) {
                utmId = urlParams.get('utm_id');
            }
            if (typeof utmId === 'string' && utmId.length === 0) {
                if (typeof campaignId === 'undefined') {
                    if (typeof formcampaignId === 'undefined') {
                        if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                            $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'cdcCampaignID') {
                            $fieldEle.find('input[name="' + formFieldId + '"]').val(siteCampaignId);
                        }
                    }
                    else {
                        if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                            $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'cdcCampaignID') {
                            $fieldEle.find('input[name="' + formFieldId + '"]').val(formcampaignId);
                        }
                    }
                }
                else {
                    if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                        $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'cdcCampaignID') {
                        $fieldEle.find('input[name="' + formFieldId + '"]').val(campaignId);
                    }
                }
            }
            else {
                if ($fieldEle.find('input[name="' + formFieldId + '"]').attr('type') == 'hidden' &&
                    $fieldEle.find('input[name="' + formFieldId + '"]').attr('name') == 'cdcCampaignID') {
                    $fieldEle.find('input[name="' + formFieldId + '"]').val(utmId);
                }
            }
        });
    };
    ButtonSapcdcFunction.prototype.productAutoSuggest = function ($component, sitecoreFormId) {
        var _this = this;
        $component = $($component);
        var sitecoreFormComponent = $(sitecoreFormId);
        var autosuggestObjJsonStr = $component.find("div[data-map-id='autosuggestObj']").text();
        if (autosuggestObjJsonStr.length > 0) {
            var autoObj_1 = JSON.parse(autosuggestObjJsonStr);
            if (autoObj_1.FieldName && autoObj_1.FieldName.length > 0) {
                var $autoEle_1 = sitecoreFormComponent.find("." + this.classes.autoSuggestDropdown);
                // disable browser's autocomplete feature
                sitecoreFormComponent
                    .find("input[data-sc-field-name='" + autoObj_1.FieldName + "']")
                    .on('focus', function (ev) {
                    $(ev.currentTarget).attr('autocomplete', 'off');
                });
                sitecoreFormComponent
                    .find("input[data-sc-field-name='" + autoObj_1.FieldName + "']")
                    .on('input propertychange', function (ev) {
                    var $target = $(ev.currentTarget);
                    $target.attr('data-t-uvpno', '');
                    $target.addClass('js-m-cdc-form-productname', '');
                    var val = $target.val();
                    if (val.length >= 2) {
                        $.ajax({
                            type: 'GET',
                            url: autoObj_1.Endpoint,
                            dataType: 'json',
                            data: {
                                term: val,
                                permissionQuery: autoObj_1.PermissionQuery,
                                max: autoObj_1.MaxItem,
                                lang: autoObj_1.Language,
                            },
                            success: function (response) {
                                if (response) {
                                    // clear dropdown
                                    $autoEle_1.empty();
                                    // render brand dropdown items
                                    //_this.renderDropdown($autoEle, response.suggestions, autoObj.BrandLabel);
                                    // render product dropdown items
                                    _this.renderDropdown($autoEle_1, response.productSuggestions, autoObj_1.ProductLabel);
                                    // rebind dropdown items event
                                    if ($autoEle_1.children().length > 0) {
                                        _this.rebindDropdownEvents(sitecoreFormComponent, autoObj_1.FieldName, $component);
                                    }
                                    // render no result found label
                                    else {
                                        var labelContent = _this.generateDropdownLabelContent(val, autoObj_1.NoResultLabel);
                                        $autoEle_1.append(labelContent);
                                    }
                                    _this.showDropdown($autoEle_1, $target);
                                }
                            },
                            complete: function () { },
                            error: function (xhr, status, error) {
                                console.log("sapcdc form, get product auto-suggest data error, " + xhr.status + ", " + xhr.statusText + ", " + error);
                            },
                        });
                    }
                    else {
                        $autoEle_1.removeAttr('style');
                    }
                });
                _this.resizeDropdown(sitecoreFormComponent, autoObj_1.FieldName);
                _this.autoHideDropdown(sitecoreFormComponent, autoObj_1.FieldName);
            }
        }
    };
    ButtonSapcdcFunction.prototype.generateDropdownItemContent = function (text, uvptext) {
        var htmlContent = "<li class=\"m-sapcdc-form__filter-dropdown-item " + this.classes.dropdownItem + "\" data-t-uvp=" + uvptext + ">" + text + "</li>";
        return htmlContent;
    };
    ButtonSapcdcFunction.prototype.generateDropdownLabelContent = function (text, NoResultLabel) {
        if (NoResultLabel === void 0) { NoResultLabel = ''; }
        if (text == 'Product') {
            var htmlContent = "<li class=\"m-sapcdc-form__filter-dropdown-item m-sapcdc-form__filter-dropdown-item--label js-m-sapcdc-form_dropdown-label\">" + text + "</li>";
            return htmlContent;
        }
        else {
            var htmlContent = "<li class=\"m-sapcdc-form__filter-dropdown-item m-sapcdc-form__filter-dropdown-item--label js-m-sapcdc-form_dropdown-label m-sapcdc-form__noresult\"> " + NoResultLabel + " <b>" + text + "</b></li>";
            return htmlContent;
        }
    };
    ButtonSapcdcFunction.prototype.resizeDropdown = function ($component, fieldName) {
        var _this_1 = this;
        $(window).on('resize', function () {
            var $target = $component.find("input[data-sc-field-name='" + fieldName + "']");
            if ($target.length > 0) {
                var currentTop = $target.closest('.o-form__grid-row').position().top + $target.outerHeight();
                var currentLeft = $target.closest('.o-form__grid-row').position().left;
                var currentWidth = $target.outerWidth();
                $component.find("." + _this_1.classes.autoSuggestDropdown).css({
                    top: currentTop + "px",
                    left: currentLeft + "px",
                    width: currentWidth + "px",
                });
            }
        });
    };
    ButtonSapcdcFunction.prototype.renderDropdown = function ($autoEle, data, label) {
        var _this_1 = this;
        if (data && data.length > 0) {
            var labelContent = this.generateDropdownLabelContent(label);
            $autoEle.append(labelContent);
            data.forEach(function (d) {
                var htmlContent = _this_1.generateDropdownItemContent(d.value, d.uvp);
                $autoEle.append(htmlContent);
            });
        }
    };
    ButtonSapcdcFunction.prototype.rebindDropdownEvents = function ($component, fieldName, cdpFormComponent) {
        var _this = this;
        $component.find("." + this.classes.dropdownItem).on('click', function (e) {
            var $target = $(e.target);
            var value = $target.text();
            var uvpno = $target.attr('data-t-uvp');
            $component.find("input[data-sc-field-name='" + fieldName + "']").val(value);
            $component.find("input[data-sc-field-name='" + fieldName + "']").attr('data-t-uvpno', uvpno);
            _this.setProductInfo($component, value, cdpFormComponent);
        });
    };
    ButtonSapcdcFunction.prototype.setProductInfo = function ($component, value, cdpFormComponent) {
        var autosuggestObjJsonStr = cdpFormComponent.find("div[data-map-id='autosuggestObj']").text();
        if (autosuggestObjJsonStr.length > 0) {
            var autoObj = JSON.parse(autosuggestObjJsonStr);
            $.ajax({
                type: 'GET',
                url: autoObj.Endpoint,
                dataType: 'json',
                data: {
                    term: value,
                    permissionQuery: autoObj.PermissionQuery,
                    max: autoObj.MaxItem,
                    lang: autoObj.Language,
                    extended: 'true',
                },
                success: function (response) {
                    if (response) {
                        if (response.productSuggestions && response.productSuggestions.length > 0) {
                            var uvpFieldName = 'ProductUvp';
                            //set hidden productUVP value
                            if (cdpFormComponent.attr('data-UvPFieldName').length > 0) {
                                uvpFieldName = cdpFormComponent.attr('data-UvPFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + uvpFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].uvp) {
                                    $component
                                        .find("input[data-sc-field-name='" + uvpFieldName + "']")
                                        .val(response.productSuggestions[0].uvp);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + uvpFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredProductBrandInterest value
                            var brandFieldName = 'InferredProductBrandInterest';
                            if (cdpFormComponent.attr('data-BrandFieldName').length > 0) {
                                brandFieldName = cdpFormComponent.attr('data-BrandFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + brandFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].brand) {
                                    $component
                                        .find("input[data-sc-field-name='" + brandFieldName + "']")
                                        .val(response.productSuggestions[0].brand);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + brandFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredMaterialInterest value
                            var materialFieldName = 'InferredMaterialInterest';
                            if (cdpFormComponent.attr('data-MaterialFieldName').length > 0) {
                                materialFieldName = cdpFormComponent.attr('data-MaterialFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + materialFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].materials &&
                                    response.productSuggestions[0].materials.length > 0) {
                                    var value = '';
                                    if (response.productSuggestions[0].materials.length == 1) {
                                        value = response.productSuggestions[0].materials[0];
                                    }
                                    else {
                                        response.productSuggestions[0].materials.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[data-sc-field-name='" + materialFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + materialFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredApplicationInterest value
                            var applicationFieldName = 'InferredApplicationInterest';
                            if (cdpFormComponent.attr('data-ApplicationFieldName').length > 0) {
                                applicationFieldName = cdpFormComponent.attr('data-ApplicationFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + applicationFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].applications &&
                                    response.productSuggestions[0].applications.length > 0) {
                                    var value = '';
                                    if (response.productSuggestions[0].applications.length == 1) {
                                        value = response.productSuggestions[0].applications[0];
                                    }
                                    else {
                                        response.productSuggestions[0].applications.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[data-sc-field-name='" + applicationFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + applicationFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredIndustryInterest value
                            var industryFieldName = 'InferredIndustryInterest';
                            if (cdpFormComponent.attr('data-IndustryFieldName').length > 0) {
                                industryFieldName = cdpFormComponent.attr('data-IndustryFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + industryFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].industries &&
                                    response.productSuggestions[0].industries.length > 0) {
                                    var value = '';
                                    if (response.productSuggestions[0].industries.length == 1) {
                                        value = response.productSuggestions[0].industries[0];
                                    }
                                    else {
                                        response.productSuggestions[0].industries.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[data-sc-field-name='" + industryFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + industryFieldName + "']").val('');
                                }
                            }
                            //set hidden inferredBUInterest value
                            var businessUnitFieldName = 'InferredBUInterest';
                            if (cdpFormComponent.attr('data-BusinessUnitFieldName').length > 0) {
                                businessUnitFieldName = cdpFormComponent.attr('data-BusinessUnitFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + businessUnitFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].businessUnits &&
                                    response.productSuggestions[0].businessUnits.length > 0) {
                                    var value = '';
                                    if ((response.productSuggestions[0].businessUnits.length = 1)) {
                                        value = response.productSuggestions[0].businessUnits[0];
                                    }
                                    else {
                                        response.productSuggestions[0].businessUnits.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[data-sc-field-name='" + businessUnitFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + businessUnitFieldName + "']").val('');
                                }
                            }
                            //set hidden BusinessEntity value
                            var businessEntityFieldName = 'CdcBusinessEntity';
                            if (cdpFormComponent.attr('data-BusinessEntityFieldName').length > 0) {
                                businessEntityFieldName = cdpFormComponent.attr('data-BusinessEntityFieldName');
                            }
                            if ($component.find("input[data-sc-field-name='" + businessEntityFieldName + "']").length > 0) {
                                if (response.productSuggestions[0].businessEntity &&
                                    response.productSuggestions[0].businessEntity.length > 0) {
                                    var value = '';
                                    if ((response.productSuggestions[0].businessEntity.length = 1)) {
                                        value = response.productSuggestions[0].businessEntity[0];
                                    }
                                    else {
                                        response.productSuggestions[0].businessEntity.forEach(function (d) {
                                            value = value + d + '; ';
                                        });
                                    }
                                    $component.find("input[data-sc-field-name='" + businessEntityFieldName + "']").val(value);
                                }
                                else {
                                    $component.find("input[data-sc-field-name='" + businessEntityFieldName + "']").val('');
                                }
                            }
                        }
                    }
                },
                complete: function () { },
                error: function (xhr, status, error) {
                    console.log("sapcdc form, get product auto-suggest data error, " + xhr.status + ", " + xhr.statusText + ", " + error);
                },
            });
        }
    };
    ButtonSapcdcFunction.prototype.showDropdown = function ($autoEle, $fieldEle) {
        var currentTop = $fieldEle.closest('.o-form__grid-row').position().top + $fieldEle.outerHeight();
        var currentLeft = $fieldEle.closest('.o-form__grid-row').position().left;
        var currentWidth = $fieldEle.outerWidth();
        $autoEle.css({
            top: currentTop + "px",
            left: currentLeft + "px",
            width: currentWidth + "px",
        });
        $autoEle.show();
    };
    ButtonSapcdcFunction.prototype.autoHideDropdown = function ($component, fieldName) {
        var _this_1 = this;
        $component.find("input[data-sc-field-name='" + fieldName + "']").on('click', function (ev) {
            ev.stopPropagation();
        });
        $('body').on('click', function () {
            $component.find("." + _this_1.classes.autoSuggestDropdown).removeAttr('style');
            var uvpno = $component.find('.js-m-cdc-form-productname').attr('data-t-uvpno');
            if (uvpno === undefined || uvpno === '') {
                $component.find('.js-m-cdc-form-productname').val('');
            }
        });
    };
    ButtonSapcdcFunction.prototype.stop = function () { };
    ButtonSapcdcFunction.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root',
                },] }
    ];
    /** @nocollapse */
    ButtonSapcdcFunction.ctorParameters = function () { return []; };
    ButtonSapcdcFunction.propDecorators = {
        button: [{ type: Input }],
        emitEvent: [{ type: Input }],
        buttonClick: [{ type: Output }]
    };
    ButtonSapcdcFunction.ngInjectableDef = i0.defineInjectable({ factory: function ButtonSapcdcFunction_Factory() { return new ButtonSapcdcFunction(); }, token: ButtonSapcdcFunction, providedIn: "root" });
    return ButtonSapcdcFunction;
}());
export { ButtonSapcdcFunction };
function cdpSubmitCallForSitecoreForms(event) {
    var sitecoreForm = $(event.target).closest('form');
    if (sitecoreForm) {
        var formType = $(sitecoreForm)
            .find("input[data-sc-field-name='FormType']")
            .val();
        switch (formType) {
            case 'RequestASampleForm':
                submitRequestASampleDataToCdp(sitecoreForm);
                break;
            case 'RequestAQuoteForm':
                submitRequestAQuoteDataToCdp(sitecoreForm);
                break;
        }
    }
}
function cdpSubmitCallForCdcForms(cdcFormContainer, userDetails, campaignId) {
    var sendDataToPreferences = cdcFormContainer.getAttribute('data-cdp-send-preferences-data');
    var submissionType = cdcFormContainer.getAttribute('data-form-submission-type');
    var submissionSource = cdcFormContainer.getAttribute('data-form-submission-source');
    var selectedPreference = sendDataToPreferences !== undefined && sendDataToPreferences === 'true'
        ? encodeURIComponent(window.dataLayer[0].preferenceTag)
        : '';
    switch (submissionType) {
        case 'Newsletter':
            SubmitNewsLetterPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId);
            break;
        case 'Web Content Download':
            SubmitWebContentDownloadPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId);
            break;
        case 'Webinar':
            SubmitWebinarPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId);
            break;
        default:
            SubmitDefaultPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId);
            break;
    }
}
function updateDateBoxes(dateboxes) {
    dateboxes.forEach(function (datebox) {
        datebox.previousElementSibling.classList.add('state-a-label--is-floated');
    });
}
function updateSelectList(selectboxes) {
    selectboxes.forEach(function (selectBox) {
        selectBox.previousElementSibling.classList.add('state-a-label--is-floated');
    });
}
function updateNumberBoxes(inputBoxes, errorMsg) {
    inputBoxes.forEach(function (inputBox) {
        var placeholderVal = inputBox.placeholder;
        if (placeholderVal !== undefined && placeholderVal !== '') {
            inputBox.previousElementSibling.classList.add('state-a-label--is-floated');
        }
        else {
            inputBox.addEventListener('focus', function (event) {
                $(event.target)
                    .prev('label')
                    .addClass('state-a-label--is-floated');
                $(event.target)
                    .closest(errorMsg)
                    .css('display', 'none');
            });
            inputBox.addEventListener('blur', function (event) {
                if (event.target.value === '') {
                    $(event.target)
                        .prev('label')
                        .removeClass('state-a-label--is-floated');
                }
                $(event.target)
                    .closest(errorMsg)
                    .css('display', 'block');
            });
        }
    });
}
function submitRequestASampleDataToCdp(sitecoreForm) {
    var requestASampleFormData = {
        primaryEmail: $(sitecoreForm)
            .find("input[data-sc-field-name='PrimaryEmailAddress']")
            .val(),
        cov_product_id: $(sitecoreForm)
            .find("input[data-sc-field-name='ProductName']")
            .attr('data-t-uvpno'),
        cov_prod_descr: $(sitecoreForm)
            .find("input[data-sc-field-name='ProductName']")
            .val(),
        cov_quantity_per_kg: $(sitecoreForm)
            .find("input[data-sc-field-name='SampleQuantityPerKg']")
            .val(),
        cov_submission_src: $(sitecoreForm)
            .find("input[data-sc-field-name='SubmissionSource']")
            .val(),
        cov_submission_type: $(sitecoreForm)
            .find("input[data-sc-field-name='SubmissionType']")
            .val(),
        cov_submission_date: '',
        cov_agreed_action: '',
        cov_industry: $(sitecoreForm)
            .find("input[data-sc-field-name='IndustryInterest']")
            .val(),
        cov_campaign_id: $(sitecoreForm)
            .find("input[data-sc-field-name='CdcCampaignId']")
            .val(),
        cov_addition_source: '',
        cov_lead_comments: $(sitecoreForm)
            .find("textarea[data-sc-field-name='Comment']")
            .val(),
        cov_potentl_yly_qty: $(sitecoreForm)
            .find("input[data-sc-field-name='PotentialyearlyQuantityKg']")
            .val(),
        cov_shipping_addr: $(sitecoreForm)
            .find("textarea[data-sc-field-name='ShippingAddress']")
            .val(),
        cov_form_url: window.location.href,
        cov_infr_int_ind: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredIndustryInterest']")
            .val(),
        cov_infr_int_be: $(sitecoreForm)
            .find("input[data-sc-field-name='CdcBusinessEntity']")
            .val(),
        cov_infr_int_mat: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredMaterialInterest']")
            .val(),
        cov_infr_int_app: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredApplicationInterest']")
            .val(),
        cov_infr_int_brnd: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredProductBrandInterest']")
            .val(),
        cov_cookie_id: localStorage.getItem('gig_cdp_gmid'),
        cov_price_per_kg: '',
        cov_currency: '',
        cov_pref_early_del: '',
        cov_pref_late_del: '',
        cov_form_type: $(sitecoreForm)
            .find("input[data-sc-field-name='FormType']")
            .val(),
        firstName: $(sitecoreForm)
            .find("input[data-sc-field-name='FirstName']")
            .val(),
        lastName: $(sitecoreForm)
            .find("input[data-sc-field-name='LastName']")
            .val(),
    };
    ajaxCallForCdpFormDataSubmit(requestASampleFormData);
}
function submitRequestAQuoteDataToCdp(sitecoreForm) {
    var requestAQuoteFormData = {
        primaryEmail: $(sitecoreForm)
            .find("input[data-sc-field-name='PrimaryEmailAddress']")
            .val(),
        cov_product_id: $(sitecoreForm)
            .find("input[data-sc-field-name='ProductName']")
            .attr('data-t-uvpno'),
        cov_prod_descr: $(sitecoreForm)
            .find("input[data-sc-field-name='ProductName']")
            .val(),
        cov_quantity_per_kg: $(sitecoreForm)
            .find("input[data-sc-field-name='Quantitykg']")
            .val(),
        cov_submission_src: $(sitecoreForm)
            .find("input[data-sc-field-name='SubmissionSource']")
            .val(),
        cov_submission_type: $(sitecoreForm)
            .find("input[data-sc-field-name='SubmissionType']")
            .val(),
        cov_submission_date: '',
        cov_agreed_action: '',
        cov_industry: $(sitecoreForm)
            .find("input[data-sc-field-name='IndustryInterest']")
            .val(),
        cov_campaign_id: $(sitecoreForm)
            .find("input[data-sc-field-name='CdcCampaignId']")
            .val(),
        cov_addition_source: '',
        cov_lead_comments: $(sitecoreForm)
            .find("textarea[data-sc-field-name='Comment']")
            .val(),
        cov_potentl_yly_qty: $(sitecoreForm)
            .find("input[data-sc-field-name='PotentialyearlyQuantityKg']")
            .val(),
        cov_shipping_addr: $(sitecoreForm)
            .find("textarea[data-sc-field-name='ShippingAddress']")
            .val(),
        cov_form_url: window.location.href,
        cov_infr_int_ind: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredIndustryInterest']")
            .val(),
        cov_infr_int_be: $(sitecoreForm)
            .find("input[data-sc-field-name='CdcBusinessEntity']")
            .val(),
        cov_infr_int_mat: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredMaterialInterest']")
            .val(),
        cov_infr_int_app: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredApplicationInterest']")
            .val(),
        cov_infr_int_brnd: $(sitecoreForm)
            .find("input[data-sc-field-name='InferredProductBrandInterest']")
            .val(),
        cov_cookie_id: localStorage.getItem('gig_cdp_gmid'),
        cov_price_per_kg: $(sitecoreForm)
            .find("input[data-sc-field-name='Pricekg']")
            .val(),
        cov_currency: $(sitecoreForm)
            .find("select[data-sc-field-name='Currency']")
            .val(),
        cov_pref_early_del: $(sitecoreForm)
            .find("input[data-sc-field-name='PreferredEarliestDelivery']")
            .val(),
        cov_pref_late_del: $(sitecoreForm)
            .find("input[data-sc-field-name='PreferredLatestDelivery']")
            .val(),
        cov_form_type: $(sitecoreForm)
            .find("input[data-sc-field-name='FormType']")
            .val(),
        firstName: $(sitecoreForm)
            .find("input[data-sc-field-name='FirstName']")
            .val(),
        lastName: $(sitecoreForm)
            .find("input[data-sc-field-name='LastName']")
            .val(),
    };
    ajaxCallForCdpFormDataSubmit(requestAQuoteFormData);
}
function ajaxCallForCdpFormDataSubmit(requestData) {
    $.ajax({
        url: 'api/sapcdp/sendrequestformdatatocdp',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(requestData),
        success: function (response) {
            console.log('Response received from server:', response);
        },
        error: function (xhr, status, error) {
            console.error('Error occurred:', status, error);
        },
    });
}
function SubmitNewsLetterPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId) {
    $.ajax({
        type: 'GET',
        url: window.location.origin +
            '/partial-updates/sapcdc/updatepreferencesincdp?' +
            'userPreference=' +
            selectedPreference +
            '&emailId=' +
            encodeURIComponent(userDetails.email) +
            '&campaignId=' +
            campaignId +
            '&submissionType=' +
            submissionType +
            '&submissionSource=' +
            submissionSource +
            '&firstName=' +
            userDetails.firstName +
            '&lastName=' +
            userDetails.lastName +
            '&formUrl=' +
            encodeURIComponent(window.location.href) +
            '&cookieId=' +
            localStorage.getItem('gig_cdp_gmid'),
        dataType: 'html',
        success: function (response) { },
        complete: function () { },
    });
}
function SubmitWebContentDownloadPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId) {
    $.ajax({
        type: 'GET',
        url: window.location.origin +
            '/partial-updates/sapcdc/updatepreferencesincdp?' +
            'userPreference=' +
            selectedPreference +
            '&emailId=' +
            encodeURIComponent(userDetails.email) +
            '&campaignId=' +
            campaignId +
            '&submissionType=' +
            submissionType +
            '&submissionSource=' +
            submissionSource +
            '&firstName=' +
            userDetails.firstName +
            '&lastName=' +
            userDetails.lastName +
            '&formUrl=' +
            encodeURIComponent(window.location.href) +
            '&cookieId=' +
            localStorage.getItem('gig_cdp_gmid'),
        dataType: 'html',
        success: function (response) {
            console.log('Web content download preferences updated successfully.');
        },
        error: function (xhr, status, error) {
            console.error('Error updating web content download preferences:', status, error);
        },
    });
}
function SubmitWebinarPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId) {
    $.ajax({
        type: 'GET',
        url: window.location.origin +
            '/partial-updates/sapcdc/updatepreferencesincdp?' +
            'userPreference=' +
            selectedPreference +
            '&emailId=' +
            encodeURIComponent(userDetails.email) +
            '&campaignId=' +
            campaignId +
            '&submissionType=' +
            submissionType +
            '&submissionSource=' +
            submissionSource +
            '&firstName=' +
            userDetails.firstName +
            '&lastName=' +
            userDetails.lastName +
            '&formUrl=' +
            encodeURIComponent(window.location.href) +
            '&cookieId=' +
            localStorage.getItem('gig_cdp_gmid'),
        dataType: 'html',
        success: function (response) {
            console.log('Webinar preferences updated successfully.');
        },
        error: function (xhr, status, error) {
            console.error('Error updating webinar preferences:', status, error);
        },
    });
}
function SubmitDefaultPreferences(submissionType, submissionSource, selectedPreference, userDetails, campaignId) {
    $.ajax({
        type: 'GET',
        url: window.location.origin +
            '/partial-updates/sapcdc/updatepreferencesincdp?' +
            'userPreference=' +
            selectedPreference +
            '&emailId=' +
            encodeURIComponent(userDetails.email) +
            '&campaignId=' +
            campaignId +
            '&submissionType=' +
            submissionType +
            '&submissionSource=' +
            submissionSource +
            '&firstName=' +
            userDetails.firstName +
            '&lastName=' +
            userDetails.lastName +
            '&formUrl=' +
            encodeURIComponent(window.location.href) +
            '&cookieId=' +
            localStorage.getItem('gig_cdp_gmid'),
        dataType: 'html',
        success: function (response) {
            console.log('Default preferences updated successfully.');
        },
        error: function (xhr, status, error) {
            console.error('Error updating default preferences:', status, error);
        },
    });
}
//# sourceMappingURL=button.component.cdc.js.map